(function () {
    'use strict';

    // ReSharper disable once UndeclaredGlobalVariableUsing
    angular
        .module('app.service')
        .factory('coreService', coreservice);

    // ReSharper disable once InconsistentNaming
    /* @ngInject */
    function coreservice($http, $q, exception, logger, config, $httpParamSerializerJQLike, $odata, moment) {
        var service = {
            httpAccountsGet: httpAccountsGet,
            httpAccountsGetAbortCapable: httpAccountsGetAbortCapable,
            httpAccountsPost: httpAccountsPost,
            httpAccountsPostAbortCapable: httpAccountsPostAbortCapable,
            httpGet: httpGet,
            httpGetAbortCapable: httpGetAbortCapable,
            httpPost: httpPost,
            httpPostAbortCapable: httpPostAbortCapable,
            updateQueryStringParameter: updateQueryStringParameter,
            generateGUID: generateGUID,
            processODataFilters: processODataFilters,
            processODataSort: processODataSort,
            processODataPage: processODataPage,
            success: success,
            fail: fail
        };

        return service;

        function updateQueryStringParameter(uri, key, value) {
            if (key === undefined) {
                return uri;
            }
            var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
            var separator = uri.indexOf('?') !== -1 ? '&' : '?';
            if (uri.match(re)) {
                return uri.replace(re, '$1' + key + '=' + value + '$2');
            } else {
                return uri + separator + key + '=' + value;
            }
        }

        function generateGUID() {
            function s4() {
                return Math.floor((1 + Math.random()) * 0x10000)
                  .toString(16)
                  .substring(1);
            }
            return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
              s4() + '-' + s4() + s4() + s4();
        }

        function httpAccountsGet(path, hideOverlay) {
            return httpGet(config.apiUrl, path, hideOverlay);
        }

        function httpAccountsGetAbortCapable(path, aborter) {
            return httpGetAbortCapable(config.apiUrl, path, aborter);
        }

        function httpAccountsPost(path, data) {
            return httpPost(config.apiUrl, path, data);
        }

        function httpAccountsPostAbortCapable(path, data, aborter) {
            return httpPostAbortCapable(config.apiUrl, path, data, aborter);
        }

        function httpGet(apiURL, path, hideOverlay) {
            hideOverlay = hideOverlay || false;
            return $http({
                method: 'GET',
                url: apiURL + path,
                hideOverlay: hideOverlay
            }).then(success)
            .catch(fail);
        }

        function httpGetAbortCapable(apiURL, path, aborter) {
            return $http({
                method: 'GET',
                url: apiURL + path,
                timeout: aborter.promise
            }).then(success)
              .catch(fail);
        }

        function httpPost(apiURL, path, data) {
            return $http({
                method: 'POST',
                url: apiURL + path,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                data: $httpParamSerializerJQLike(data)
            }).then(success)
              .catch(fail);
        }

        function httpPostAbortCapable(apiURL, path, data, aborter) {
            return $http({
                method: 'POST',
                url: apiURL + path,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                data: $httpParamSerializerJQLike(data),
                timeout: aborter.promise
            }).then(success)
              .catch(fail);
        }

        function success(response) {
            if (response.status === 204) {
                return { status: response.status, data: response.statusText };
            }
            return { status: response.status, data: response.data };
        }

        function fail(e) {
            var error = {
                data: {
                    description: e.data.Message,
                    ExceptionMessage: e.data.ExceptionMessage || e.data.Message,
                    error: e.data
                }
            };
            return exception.catcher('XHR Failed:')(error);
        }

        // Usage: query ::= $odataresource, predicateFilterState ::= tableState.search.predicateObject,
        // filterDescriptionArray ::= array of ['Web table value', 'Entity Framework value', 'Type of query']
        function processODataFilters(query, predicateFilterState, filterDescriptionArray) {
            if (!!predicateFilterState) {
                var data = filterDescriptionArray;

                var map = {
                    bool: handleODataBoolFilter,
                    badge: handleODataBoolFilter,
                    nullable: handleODataNullFilter,
                    date: handleODataDateFilter,
                    datetime: handleODataDateFilter,
                    guid: handleODataGuidFilter,
                    int: handleODataIntFilter,
                    dropDown: handleODataIntFilter,
                    subItem: handleODataMatchFilter,
                    match: handleODataMatchFilter,
                    raw: handleODataRawFilter,
                    multiSelect: handleODataAnyFilter,
                    multiBadge: handleODataIntFilter
                };

                for (var i = 0; i < data.length; ++i) {
                    if (predicateFilterState.hasOwnProperty(data[i].id) && !!predicateFilterState[data[i].id]) {
                        map[data[i].type](query, data[i].ODataKey, predicateFilterState[data[i].id]);
                    }

                }
            }
        }

        function handleODataBoolFilter(query, oDataName, value) {
            query.filter(oDataName, new $odata.Value(value, 'Boolean'));
        }
        
        function handleODataNullFilter(query, oDataName, value) {
            var nullFilter = value === 'false' ? '==' : '!=';
            query.filter(oDataName, nullFilter, null);
        }
     
        function handleODataDateFilter(query, oDataName, value) {
            var startDate = moment(value.startDate).toDate();
            var endDate = moment(value.endDate).toDate();

            var rangePredicate = $odata.Predicate(oDataName, '>=', startDate).and(oDataName, '<=', endDate);
            query.filter(rangePredicate);
        }

        function handleODataGuidFilter(query, oDataName, value) {
            query.filter(new $odata.Func('contains', new $odata.Func('cast',
                oDataName, 'Edm.String'), value));
        }

        function handleODataIntFilter(query, oDataName, value) {
            query.filter(oDataName, new $odata.Value(
                parseInt(value).toString(), 'Int32'));
        }

        function handleODataMatchFilter(query, oDataName, value) {
            query.filter(new $odata.Func('contains', new $odata.Property(oDataName), new $odata.Value(value)));
        }

        function handleODataRawFilter(query, oDataName, value) {
            query.filter(oDataName, value);
        }

        function handleODataAnyFilter(query, oDataName, value) {
            var OdataNames = oDataName.split(/[/]+/);
            var predicate1 = new $odata.Predicate('r/' + OdataNames.pop(), value);
            var func = new $odata.Func('any', OdataNames.join('/'), 'r', predicate1);
            query.filter(func);
        }

        function processODataSort(query, sortState) {
            if (sortState.hasOwnProperty('predicate')) {
                query.orderBy(sortState.predicate, sortState.reverse ? 'desc' : '');
            }
        }

        function processODataPage(query, pagingState) {
            if (typeof pagingState === 'undefined') {
                query.skip(0).take(10);
            } else {
                query.skip(pagingState.start).take(pagingState.number);
            }
        }
    }
})();
